import Component from '../abstracts/Component';

export default class ArticleTwinScrollComponent extends Component {

  get COMPONENTNAME() {
    return 'ArticleTwinScrollComponent';
  }

  get SELECTORS() {
    return {
      main: '[data-ts-main]',
      media: '[data-ts-media]',
      details: '[data-ts-details]',
      secondary: '[data-ts-secondary]',
      text: '[data-ts-text]',
      carousel: '[data-ts-carousel]',
      ctaShow: '[data-cta-show]',
      ctaHide: '[data-cta-hide]',
      prevArrow: '[data-prev-arrow]',
      nextArrow: '[data-next-arrow]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.main = this.$component.querySelector(this.SELECTORS.main);
    this.details = this.$component.querySelector(this.SELECTORS.details);
    this.secondary = this.$component.querySelector(this.SELECTORS.secondary);
    this.text = this.$component.querySelector(this.SELECTORS.text);
    this.media = this.$component.querySelector(this.SELECTORS.media);
    this.carousel = this.$component.querySelector(this.SELECTORS.carousel);
    this.ctaShow = this.$component.querySelector(this.SELECTORS.ctaShow);
    this.ctaHide = this.$component.querySelector(this.SELECTORS.ctaHide);
  }

  toggleCarousel() {
    this.ctaShow.addEventListener('click', () => {
      this.media.classList.add('carousel');
    });
    this.ctaHide.addEventListener('click', () => {
      this.media.classList.remove('carousel');
    });
  }

  setCenter() {
    let viewHeight = window.innerHeight;
    let mainHeight = this.main.offsetHeight;
    let headerHeight = document.querySelector('header').offsetHeight;
    let halfViewHeight = (viewHeight - headerHeight) / 2 + headerHeight;
    let position = halfViewHeight - mainHeight / 2;
    let root = document.documentElement;
    root.style.setProperty('--article-ts-center', `${position}px`);
  }

  setMargins() {
    if (window.matchMedia('(min-width: 768px)').matches) {
      let detailsHeight = this.details.offsetHeight;
      this.text.style.marginBottom = `${detailsHeight}px`;
      this.secondary.style.marginBottom = `${detailsHeight}px`;
    }
  }

  setOptions() {
    const customPaging = function(slider, i) {
      return $('<i class="icon-slider-bullet"></i><i class="icon-slider-bullet-active"></i>');
    };
    let responsiveArray = [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1.8,
        },
      },
    ];
    let options = {
      slidesToShow: 2.7,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: false,
      swipe: true,
      draggable: true,
      responsive: responsiveArray,
      prevArrow: '<button type="button" class="w__slick-prev icon-slick-prev" aria-label="previous slide" data-prev-arrow><i class="icon-slick-prev"></i></button>',
      nextArrow: '<button type="button" class="w__slick-next icon-slick-next" aria-label="next slide" data-next-arrow><i class="icon-slick-next"></i></button>',
      customPaging: customPaging,
    };
    this.initCarousel(options);
  }

  initCarousel(options) {
    $(this.carousel).on('init', () => {
      this.animateArrows();
    });
    $(this.carousel).slick(options);
  }

  animateArrows() {
    let prevArrow = this.carousel.querySelector(this.SELECTORS.prevArrow);
    if (prevArrow) {
      prevArrow.addEventListener('mousedown', () => {
        prevArrow.classList.remove('transition');
      });
      prevArrow.addEventListener('click', () => {
        prevArrow.classList.add('transition');
      });
    }
    let nextArrow = this.carousel.querySelector(this.SELECTORS.nextArrow);
    if (nextArrow) {
      nextArrow.addEventListener('mousedown', () => {
        nextArrow.classList.remove('transition');
      });
      nextArrow.addEventListener('click', () => {
        nextArrow.classList.add('transition');
      });
    }
  }

  importSlick() {
    this.moduleLoader.loadCarouselAndExecute(module => {
        this.setOptions();
      },
      error => {
        console.error('failed to load slick', error.stack);
      }
    );
  }

  render() {
    this.log('Rendering...');
    this.setCenter();
    this.setMargins();
    if (this.carousel) {
      this.importSlick();
      this.toggleCarousel();
    }
  }
}
